import React, {useContext, useEffect, useState} from "react";
import {RoleContext} from "../context/role-context.jsx";
import roleUtils from "../utils/role-utils.js";
import Button from "../../../../../components/button/button.jsx";
import {FaTriangleExclamation} from "react-icons/fa6";
import {FaInfo} from "react-icons/fa";
import DependenciesList from "../resources/dependencies-list.js";
import ConditionalDependencies from "../resources/conditional-dependencies.js";

const DependencyFormatter = (props) => {
    const {name} = props.data;
    const {permissions} = props;

    const [hasDependency, setHasDependency] = useState(false);
    const [hasDependencyNotChecked, setHasDependencyNotChecked] = useState(false);

    const {permissionsWithDependenciesNotChecked} = useContext(RoleContext);

    useEffect(() => {
        setHasDependencyNotChecked(permissionsWithDependenciesNotChecked.includes(name))
    }, [permissionsWithDependenciesNotChecked]);

    useEffect(() => {
        async function fetchData() {
            const dependencies = await roleUtils.getDependencies(name, false, permissions, DependenciesList);
            const conditionalDependencies = await roleUtils.getDependencies(name, false, permissions, ConditionalDependencies);
            if (dependencies.length > 0 || conditionalDependencies.length > 0) {
                setHasDependency(true)
            }
        }

        fetchData().then(() => {});
    }, []);

    const openModalDependencies = async () => {
        const dependencies = await roleUtils.getDependencies(name, false, permissions, DependenciesList);
        const conditionalDependencies = await roleUtils.getDependencies(name, false, permissions, ConditionalDependencies);

        props.setPermissionsDependency(dependencies);
        props.setConditionalPermissionsDependency(conditionalDependencies);

        props.setRowPermission(props.node);
        props.openModalDependencies(true);
    }

    return <>
        {
            hasDependency &&
            <div className={"h-full flex items-center justify-center"} target={"dependencies"} onClick={openModalDependencies}>
                <Button className={"!h-[25px] !w-[45px]"} target={hasDependencyNotChecked ? "warning" : "secondary"} title={"Ver dependências"}>
                    {
                        hasDependencyNotChecked &&
                        <FaTriangleExclamation />
                    }

                    {
                        !hasDependencyNotChecked &&
                        <FaInfo />
                    }
                </Button>
            </div>
        }
    </>
}

export default DependencyFormatter;